import React from 'react'
import { setPropTypes } from '../icons/BaseIcon'

function NewYorkTimesLogo({ width = 60, height = 39 }) {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height} 
    viewBox="0 0 1280.000000 1024.000000"
    preserveAspectRatio="xMidYMid meet">
   
   <g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
   fill="#000000" stroke="none">
   <path d="M5220 9731 c-23 -7 -22 -9 15 -15 102 -18 166 -61 181 -122 22 -89
   -83 -157 -206 -134 -83 16 -157 37 -392 110 -283 89 -382 108 -481 92 -151
   -25 -281 -117 -341 -242 -28 -59 -31 -73 -31 -165 0 -89 3 -105 27 -150 29
   -55 64 -91 118 -124 50 -30 54 -26 20 21 -81 111 10 259 160 258 19 -1 112
   -21 205 -45 199 -53 631 -159 694 -171 l43 -9 0 -210 -1 -210 -100 -80 c-55
   -44 -100 -82 -100 -85 0 -3 45 -41 100 -85 l99 -80 0 -110 c1 -94 1 -434 0
   -473 0 -22 -124 -71 -221 -88 -153 -26 -283 -2 -415 77 -57 34 -164 124 -164
   139 0 4 115 65 255 136 l255 129 0 453 c0 248 -3 452 -7 452 -7 0 -416 -180
   -571 -251 -62 -28 -63 -28 -57 -6 12 40 83 153 128 203 24 27 76 72 115 99 39
   28 71 53 72 56 1 25 -200 -59 -297 -124 -152 -101 -271 -233 -349 -389 -74
   -147 -89 -217 -89 -403 0 -134 4 -174 23 -245 109 -410 463 -685 877 -684 138
   1 242 27 380 94 213 104 363 294 425 534 19 75 32 236 20 236 -4 0 -15 -19
   -26 -42 -28 -64 -99 -166 -158 -227 -56 -59 -143 -131 -157 -131 -5 0 -9 119
   -8 283 l0 282 100 79 c54 44 99 83 99 87 0 3 -45 42 -100 85 l-99 79 -1 213 0
   212 33 0 c86 0 205 57 270 129 65 72 99 209 78 313 -22 106 -93 181 -215 227
   -59 22 -169 34 -206 22z m-680 -1369 l0 -438 -67 -33 -67 -33 -23 29 c-38 47
   -80 134 -114 234 -28 81 -33 111 -37 220 -3 90 0 147 12 202 28 137 27 136
   167 199 68 31 125 57 127 57 1 1 2 -196 2 -437z"/>
   <path d="M6049 9487 c-86 -67 -186 -145 -223 -174 l-67 -51 30 -18 c64 -38 61
   -6 59 -841 l-3 -758 -98 -74 c-62 -46 -95 -77 -89 -83 6 -6 26 3 55 22 31 22
   49 30 59 24 9 -5 66 -57 129 -116 63 -60 116 -108 120 -108 3 0 76 55 161 123
   85 67 175 138 201 157 42 32 60 60 38 60 -4 0 -29 -16 -55 -36 l-47 -36 -50
   53 -49 53 0 415 1 416 55 45 c30 25 58 46 62 47 4 1 47 -48 96 -109 l88 -111
   -5 -496 c-6 -533 -10 -586 -60 -694 -24 -51 -105 -139 -161 -177 -16 -10 -48
   -24 -72 -30 -24 -7 -42 -16 -39 -20 8 -13 117 -18 184 -9 179 25 328 116 417
   255 88 137 94 186 94 786 0 277 4 508 8 514 4 6 33 30 65 53 31 24 57 47 57
   52 0 18 -25 8 -78 -32 -37 -28 -59 -39 -67 -33 -7 5 -72 75 -145 156 l-132
   147 -34 -26 c-19 -14 -101 -83 -182 -154 l-147 -128 -3 530 c-1 291 -6 529
   -10 529 -4 -1 -77 -56 -163 -123z"/>
   <path d="M7635 8724 c-104 -63 -245 -144 -312 -180 l-123 -66 -1 -396 c0 -218
   -2 -408 -3 -420 -2 -13 -18 -36 -37 -50 -68 -54 -82 -69 -75 -81 5 -8 24 3 60
   34 29 25 57 45 61 45 10 0 105 -83 253 -220 57 -52 107 -96 112 -98 7 -3 509
   387 639 495 3 2 0 8 -5 13 -7 7 -67 -34 -183 -126 -152 -120 -174 -134 -189
   -122 -9 7 -76 68 -147 135 -112 105 -130 126 -129 150 1 15 3 38 3 49 1 17 72
   74 291 234 l290 213 -18 31 c-10 17 -76 131 -146 254 -71 122 -134 222 -140
   221 -6 0 -96 -52 -201 -115z m45 -281 c63 -108 127 -218 142 -244 l27 -46
   -141 -102 c-77 -57 -142 -101 -144 -98 -6 6 -10 687 -4 687 3 -1 57 -89 120
   -197z"/>
   <path d="M10748 6261 c-131 -91 -238 -169 -238 -173 0 -5 9 -8 19 -8 26 0 78
   -61 90 -107 7 -25 11 -299 11 -803 l0 -765 -70 -60 c-39 -33 -80 -68 -92 -78
   -15 -13 -18 -21 -10 -29 8 -8 25 2 63 36 l52 47 86 -83 c47 -46 107 -103 133
   -127 l46 -44 124 109 c69 60 157 136 196 169 65 55 87 85 62 85 -5 0 -27 -16
   -49 -35 -21 -19 -43 -35 -48 -35 -4 0 -37 28 -71 63 l-62 62 -2 971 -3 971
   -237 -166z"/>
   <path d="M2708 6414 c-3 -5 -8 -22 -12 -39 -19 -80 -99 -135 -194 -135 -75 0
   -134 21 -199 69 l-51 40 -159 -182 c-87 -100 -171 -196 -187 -215 -19 -22 -26
   -36 -19 -43 7 -7 27 10 62 50 l53 61 45 -35 c69 -52 141 -84 213 -92 l65 -8 3
   -515 c1 -292 -2 -510 -7 -505 -8 9 -189 337 -544 985 -76 140 -155 281 -174
   312 -46 77 -110 141 -174 175 -48 25 -64 28 -149 28 -87 0 -100 -3 -148 -30
   -70 -38 -136 -112 -162 -181 -21 -58 -38 -219 -26 -251 6 -14 12 -5 26 37 48
   142 161 148 262 15 l38 -50 0 -192 c0 -219 11 -195 -95 -208 -171 -23 -276
   -128 -277 -278 -1 -119 74 -238 171 -272 61 -21 66 -19 36 16 -21 26 -25 40
   -23 78 3 39 8 49 36 67 36 25 101 39 132 29 19 -6 20 -13 20 -281 l0 -274 -47
   0 c-223 -1 -409 -151 -441 -355 -37 -230 135 -417 381 -414 l72 0 -65 22 c-76
   26 -102 43 -135 88 -68 91 -20 216 96 251 78 23 196 -21 273 -100 l28 -30 101
   112 c259 283 279 305 271 318 -5 8 -24 -6 -59 -45 l-51 -58 -47 43 c-73 66
   -163 116 -259 146 l-88 27 0 624 c0 355 4 621 9 615 4 -5 28 -45 51 -89 24
   -44 53 -98 65 -120 13 -22 36 -65 52 -95 16 -30 131 -239 255 -465 124 -225
   254 -462 288 -525 181 -329 264 -476 274 -483 6 -4 22 -6 36 -5 l25 3 5 915 5
   914 40 7 c134 23 240 101 298 218 30 61 32 72 32 171 0 94 -13 159 -27 134z"/>
   <path d="M7415 6176 l-190 -153 -5 140 c-4 100 -9 142 -17 145 -10 3 -13 -219
   -13 -1088 l0 -1092 -22 6 c-52 15 -161 36 -184 36 l-24 0 0 928 c0 1015 1
   1002 -58 1087 -33 47 -107 100 -165 117 -23 7 -78 12 -122 13 -66 0 -90 -5
   -137 -27 -63 -29 -139 -95 -174 -149 -27 -43 -54 -131 -53 -173 l0 -31 14 38
   c8 21 24 51 35 68 62 86 175 76 222 -19 22 -46 23 -55 23 -341 l0 -295 -69
   -13 c-130 -24 -220 -88 -261 -186 -18 -43 -20 -140 -3 -188 28 -83 98 -147
   169 -156 l40 -6 -36 36 c-37 37 -41 50 -25 91 18 48 113 86 165 66 l25 -10 0
   -428 0 -429 -84 -51 c-83 -51 -135 -103 -172 -172 -15 -28 -19 -56 -19 -140 0
   -98 2 -110 32 -173 45 -95 122 -168 205 -196 140 -46 280 -38 623 35 236 50
   382 70 438 60 102 -19 122 -144 37 -236 -43 -46 -38 -48 46 -19 122 43 215
   130 244 227 39 131 18 235 -65 318 -139 139 -262 149 -743 59 -297 -55 -401
   -69 -470 -62 -74 8 -125 43 -147 101 -33 86 3 163 98 210 118 59 337 47 657
   -36 304 -79 452 -78 562 5 57 42 95 120 108 217 5 43 10 432 10 910 l0 835 71
   59 c49 40 68 61 60 69 -7 7 -27 -5 -66 -39 -31 -27 -62 -53 -69 -58 -9 -6 -55
   28 -154 117 -78 70 -143 127 -144 126 -2 0 -88 -69 -193 -153z m-2 -219 l77
   -69 0 -272 0 -271 -37 -25 c-29 -20 -49 -25 -98 -25 -52 0 -67 4 -98 28 l-37
   28 0 317 1 317 42 32 c48 36 35 41 150 -60z m-106 -692 c56 -14 114 -5 154 24
   l29 22 0 -121 c0 -66 -2 -120 -4 -120 -3 0 -20 9 -39 20 -57 34 -142 29 -199
   -12 l-28 -19 0 127 c0 126 0 127 20 109 11 -10 41 -23 67 -30z m118 -204 c22
   -10 46 -25 53 -33 10 -13 13 -97 12 -382 0 -413 -2 -420 -72 -481 -44 -37
   -126 -61 -172 -49 l-26 6 0 448 0 449 29 20 c63 45 113 51 176 22z"/>
   <path d="M3892 5915 c-102 -24 -219 -129 -257 -230 -13 -33 -16 -64 -13 -122
   6 -96 28 -142 99 -209 91 -85 111 -108 133 -154 20 -43 21 -60 24 -450 l3
   -405 -71 -49 c-38 -27 -70 -52 -70 -56 0 -19 17 -17 47 5 18 14 48 36 67 50
   l34 26 156 -132 c141 -118 159 -130 174 -117 94 79 313 248 322 248 6 0 83
   -57 171 -127 88 -71 164 -129 168 -131 5 -1 86 46 182 105 96 60 246 153 334
   207 l160 98 -3 380 c-1 208 1 385 5 392 5 7 63 61 131 120 67 59 122 111 122
   116 0 20 -24 9 -72 -35 -28 -25 -53 -45 -57 -45 -3 0 -68 52 -144 115 -76 63
   -141 115 -145 115 -4 0 -54 -44 -113 -98 -58 -53 -127 -117 -154 -141 l-48
   -44 62 -56 61 -56 0 -475 c0 -467 0 -475 -20 -488 -25 -16 -19 -20 -167 102
   l-123 100 0 394 0 394 50 56 c28 31 50 59 50 62 0 9 -201 191 -262 239 -19 14
   -30 6 -246 -188 l-83 -75 61 -61 60 -61 0 -446 0 -446 -26 -17 c-14 -9 -31
   -14 -38 -12 -7 3 -59 42 -115 87 l-101 81 0 435 c0 484 1 476 -68 548 -20 21
   -71 61 -112 88 -126 85 -180 149 -180 214 0 37 36 109 66 133 43 34 32 37 -54
   16z"/>
   <path d="M11230 5325 c-118 -173 -216 -320 -218 -328 -3 -14 552 -910 567
   -915 6 -2 231 189 379 324 72 65 46 75 -28 11 l-64 -56 -309 466 c-280 424
   -308 469 -298 490 l11 24 30 -21 c100 -71 236 -97 331 -64 105 37 198 162 233
   314 9 35 13 66 11 68 -2 3 -18 -7 -36 -22 -103 -87 -213 -92 -328 -15 -32 21
   -60 39 -62 38 -2 0 -101 -141 -219 -314z"/>
   <path d="M8650 5533 c-91 -52 -229 -127 -307 -166 l-143 -70 0 -449 c0 -246
   -3 -448 -7 -448 -5 -1 -28 -19 -52 -41 -33 -29 -41 -43 -33 -51 8 -8 23 0 57
   31 25 23 50 41 55 39 5 -2 90 -72 190 -155 99 -84 185 -153 190 -153 5 0 71
   37 147 83 76 46 220 128 321 182 l182 99 0 413 0 412 55 52 c30 28 55 56 55
   60 0 21 -29 6 -70 -36 -24 -25 -49 -45 -55 -45 -6 0 -98 76 -205 170 -107 93
   -199 169 -205 169 -5 0 -84 -43 -175 -96z m30 -189 c36 -32 98 -90 138 -129
   l72 -70 -2 -439 -3 -439 -157 142 -158 142 0 446 0 446 23 -20 c12 -11 51 -47
   87 -79z"/>
   <path d="M3090 5496 c-113 -68 -256 -149 -317 -180 l-113 -57 -1 -422 0 -422
   -55 -43 c-50 -40 -66 -62 -45 -62 4 0 31 18 59 40 27 22 54 40 58 40 9 -1 13
   -4 228 -198 87 -78 141 -120 149 -116 13 8 305 238 510 402 76 60 115 98 109
   104 -6 6 -70 -38 -177 -122 -92 -73 -173 -133 -180 -134 -6 0 -73 57 -149 128
   l-137 129 3 55 3 56 97 70 c359 263 473 349 471 356 -1 4 -40 72 -86 151 -46
   79 -110 190 -143 247 -32 56 -63 102 -69 102 -5 0 -102 -56 -215 -124z m84
   -317 c118 -205 137 -242 125 -254 -20 -19 -262 -195 -268 -195 -3 0 -6 155 -6
   345 0 190 2 345 5 345 3 -1 68 -109 144 -241z"/>
   <path d="M9568 5452 c-102 -92 -187 -173 -187 -179 -2 -24 20 -13 70 34 28 26
   53 42 57 37 5 -5 34 -43 65 -85 l57 -75 0 -385 -1 -384 -84 -74 c-47 -40 -82
   -77 -79 -82 9 -15 17 -11 68 36 26 25 52 45 57 45 5 0 62 -48 127 -107 64 -60
   130 -120 147 -135 25 -23 32 -25 46 -15 48 34 375 313 377 322 8 23 -18 12
   -73 -34 l-60 -49 -65 56 c-36 30 -71 62 -77 71 -10 11 -13 116 -13 448 0 238
   2 433 4 433 2 0 20 -16 41 -35 133 -122 307 -101 409 48 46 67 66 125 73 211
   l6 70 -40 -32 c-56 -46 -96 -55 -159 -37 -28 8 -63 24 -78 36 l-28 22 -123
   -123 -123 -122 -103 125 c-57 69 -108 126 -114 126 -5 0 -94 -75 -197 -167z"/>
   <path d="M4300 3090 c0 -5 13 -10 28 -10 134 0 235 -114 176 -199 -21 -30 -89
   -61 -135 -61 -49 0 -197 38 -404 104 -415 133 -499 140 -672 56 -97 -48 -171
   -123 -205 -210 -32 -80 -32 -226 1 -290 30 -57 76 -106 123 -131 50 -26 54
   -24 24 11 -62 75 -34 199 57 247 63 33 147 22 447 -60 318 -87 428 -114 525
   -131 l70 -12 3 -206 2 -207 -92 -77 c-51 -42 -99 -82 -106 -88 -10 -10 9 -29
   93 -96 l105 -83 0 -292 0 -291 -37 -21 c-80 -45 -181 -67 -298 -67 -130 0
   -198 19 -315 88 -74 44 -160 115 -160 132 0 5 116 68 258 139 l257 130 2 453
   c1 248 -1 452 -6 452 -5 0 -149 -63 -321 -140 -172 -77 -315 -138 -318 -136
   -8 9 68 139 111 191 51 61 93 98 166 148 55 39 56 39 21 34 -57 -8 -208 -77
   -287 -130 -96 -64 -219 -188 -282 -284 -109 -166 -157 -340 -147 -538 9 -192
   53 -340 143 -480 155 -239 416 -390 714 -411 145 -11 281 21 450 107 200 102
   329 267 395 507 25 92 43 252 28 251 -5 0 -24 -31 -42 -69 -46 -92 -145 -216
   -230 -284 -38 -31 -72 -56 -76 -56 -3 0 -6 128 -6 284 l0 284 98 77 c53 43
   101 81 105 85 4 4 -40 44 -98 91 l-105 84 3 210 2 209 40 3 c55 5 153 40 195
   71 104 76 143 159 144 302 1 88 -1 99 -30 150 -58 103 -192 170 -340 170 -43
   0 -74 -4 -74 -10z m-650 -1363 l0 -433 -70 -34 c-70 -34 -71 -34 -89 -15 -33
   34 -89 146 -122 245 -41 124 -50 272 -25 412 27 147 24 143 161 203 66 29 126
   53 133 54 9 1 12 -92 12 -432z"/>
   <path d="M4935 2670 c-71 -66 -131 -124 -133 -130 -4 -10 207 -245 219 -245 3
   0 68 56 143 124 137 123 137 123 119 145 -79 90 -206 226 -212 226 -3 -1 -64
   -55 -136 -120z"/>
   <path d="M9898 2252 c-11 -77 -61 -125 -146 -138 -57 -9 -118 15 -179 70 l-48
   43 -85 -57 c-115 -76 -270 -169 -385 -231 l-95 -51 0 -201 0 -202 108 -99 c59
   -55 109 -104 110 -108 2 -5 -36 -50 -85 -101 -178 -184 -221 -289 -178 -434
   28 -94 156 -204 235 -202 24 0 24 1 5 12 -11 7 -37 28 -57 48 -31 30 -38 44
   -38 76 0 56 41 94 109 101 60 5 114 -19 177 -79 l41 -40 119 80 c102 69 311
   196 413 253 l31 17 0 263 0 263 -120 95 c-65 52 -119 97 -120 100 0 3 27 41
   60 85 34 44 82 121 107 172 39 78 47 103 51 165 3 50 0 84 -10 108 l-15 35 -5
   -43z m-499 -325 c125 -113 271 -115 396 -6 l39 34 -20 -33 c-39 -67 -145 -191
   -254 -295 -61 -59 -115 -107 -119 -107 -4 0 -38 26 -74 58 l-66 57 -1 204 0
   204 28 -39 c16 -21 48 -56 71 -77z m169 -516 l42 -35 0 -255 0 -255 -35 60
   c-40 67 -109 135 -169 166 -28 15 -66 23 -122 26 -111 6 -167 -13 -244 -85
   -33 -30 -60 -51 -60 -46 0 6 23 41 52 79 57 75 165 186 327 336 l105 97 30
   -26 c17 -14 50 -42 74 -62z"/>
   <path d="M6951 2066 c-102 -80 -187 -146 -190 -146 -4 0 -65 63 -136 140 -71
   77 -129 140 -130 140 0 0 -82 -63 -180 -140 -99 -77 -182 -139 -185 -139 -3 0
   -63 63 -135 139 l-129 138 -51 -41 c-51 -43 -285 -246 -319 -278 -10 -9 -15
   -22 -11 -28 4 -8 28 7 67 41 l61 52 44 -49 c25 -28 65 -73 89 -101 l44 -51 0
   -346 0 -345 -45 -39 -45 -38 107 -120 c58 -66 121 -137 141 -159 l34 -39 144
   144 144 144 -60 60 -60 61 0 416 0 417 36 27 35 27 42 -48 c23 -27 68 -78 99
   -114 l58 -66 0 -340 0 -339 -40 -41 -41 -42 131 -146 c72 -81 132 -147 133
   -147 8 0 277 268 277 275 0 6 -23 34 -50 62 l-50 53 0 417 0 418 36 29 37 29
   46 -49 c25 -27 72 -77 104 -111 l57 -62 0 -342 0 -343 -35 -36 -34 -35 146
   -157 145 -158 122 112 c201 184 266 250 260 260 -6 10 -21 1 -72 -46 l-33 -31
   -69 75 -69 75 -1 396 0 397 57 43 c31 24 62 47 67 51 7 5 7 10 1 17 -7 6 -34
   -8 -79 -42 -59 -44 -70 -49 -80 -35 -11 15 -135 154 -211 236 l-40 44 -184
   -146z"/>
   <path d="M8285 2104 c-93 -56 -236 -138 -317 -181 l-147 -78 -1 -420 0 -420
   -61 -49 c-42 -33 -58 -51 -51 -58 8 -8 26 1 59 29 26 22 53 43 60 46 6 4 86
   -60 190 -153 98 -88 183 -159 190 -158 6 2 147 111 314 243 166 132 306 243
   312 246 5 4 6 12 3 18 -9 13 -33 -3 -221 -152 -75 -59 -141 -107 -145 -105 -5
   2 -72 62 -149 133 l-141 130 2 50 3 49 285 209 c157 115 287 213 288 218 2 6
   -29 67 -70 137 -41 70 -106 182 -144 249 -38 68 -73 122 -79 122 -5 -1 -86
   -48 -180 -105z m49 -340 c75 -128 136 -236 136 -240 0 -8 -232 -181 -276 -207
   -12 -7 -14 50 -14 345 0 198 4 348 9 343 4 -6 70 -114 145 -241z"/>
   <path d="M4885 2059 c-199 -174 -199 -174 -190 -189 5 -8 17 -3 39 17 78 71
   63 74 149 -28 l77 -91 1 -377 c1 -207 1 -385 0 -396 -1 -11 -27 -43 -57 -71
   -35 -32 -52 -54 -45 -58 11 -7 74 36 101 69 7 8 16 15 21 15 4 0 65 -65 134
   -145 l127 -145 121 107 c200 178 252 229 239 237 -7 4 -33 -13 -63 -41 l-51
   -48 -27 31 c-14 17 -47 56 -73 86 l-48 55 0 389 -1 389 62 56 c81 73 72 100
   -10 29 -32 -27 -61 -50 -66 -50 -4 0 -22 17 -39 37 -110 130 -228 263 -234
   263 -4 -1 -79 -64 -167 -141z"/>
   </g>
   </svg>
  )
}

setPropTypes(NewYorkTimesLogo)
export default NewYorkTimesLogo
